<template>
    <v-main fill-height :style="{ background: background, zIndex: ((mainIsVisible||autoCheckin) && isSmAndDownDevice) ? 8 : 'auto' }" style="padding:0">
        <v-container fill-height fluid class="pa-0" :class="{'px-0':isSmAndDownDevice}" style="padding-top: 5px;" :style="containerStyle">
            <v-layout justify-start :align-center="!isTabletOrPhone" :align-stretch="isTabletOrPhone">
                <div style="position:absolute;top:0;left:0;right:0;bottom:0;">
                    <slot name="background"></slot>
                </div>
                <v-flex xs12 sm12 md4 lg3 v-show="menuIsVisible && (drawer || !hideMenu)" :class="{'m-auto':(isSmAndDownDevice), 'menu-drawer': drawer, 'menu-drawer--closed': drawer && hideMenu}" >
                    <div v-if="drawer" class="menu-drawer__handle">
                        <slot name="menu-handle"></slot>
                    </div>
                    <v-card :ripple="false" rounded="xl" :height="cardHeight" style="position: relative;overflow:hidden;display: flex;flex-direction: column;" :style="(backgroundMenu)?{'background': backgroundMenu}:{}" :class="isSmAndDownDevice?'pa-0 mobileCard':'customCard'">
                        <v-card-title class="pa-0 px-3 flex-shrink-0" :style="{'background-color': theme.headerFooterColor, 'position': 'relative','overflow':'hidden'}">
                            <v-toolbar flat  class="pa-0 menu-toolbar" :color="theme.headerFooterColor">
                                <v-toolbar-title style="width: 100%;">
                                    <v-row no-gutters align="center">
                                        <v-col cols="12">
                                            <h2 class="font-weight-bold text-h5"><slot name="menu-title"></slot></h2>
                                        </v-col>
                                    </v-row>
                                </v-toolbar-title>
                            </v-toolbar>
                        </v-card-title>
                        <v-card-text class="pa-2 py-0 flex-shrink-0" v-if="$slots['menu-actions']" :style="{'background-color': theme.headerFooterColor}">
                            <slot name="menu-actions"></slot>
                        </v-card-text>
                        <v-card-text class="pa-0 flex-grow-1" style="overflow-y: auto;min-height: 0;" >
                            <!-- here -->
                            <HLLoadingMaskOverlay v-show="loadingMenu" class="ml-0 mt-3 mr-1"/>
                            <slot v-show="!loadingMenu" name="menu"></slot>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex lg1 v-if="isLgAndUpDevice &&!singleView"></v-flex>
                <!--<v-fade-transition :hide-on-leave="true">-->
                <v-flex xs12 sm12 md7 lg7 v-show="mainIsVisible" :class="{'mx-10':(isMdDevice && !singleView),'m-auto':(singleView || isSmAndDownDevice)}">
                    <!--<transition-group name="card">-->
                    <v-card :ripple="false" :key="transitionKey" rounded="xl" :height="(isSmAndDownDevice?bgHeight:cardHeight)" class="card" :class="mainCardClass" :style="mainCardStyle" :color="theme.backgroundColor" >
                        <!-- <div class="left-card-header"></div>  -->
                        <v-card-title class="task-title pl-4 pr-4 pt-1 pb-2" :style="mainTitleStyle" :class="(insetMain)?'':'px-4'">
                            <v-row no-gutters justify="center" align="center" class="pt-1">
                                <v-col cols="10" sm="11" justify="center">
                                    <h2 class="font-weight-bold" :class="(isXsDevice)?'text-h6 elipsis':'text-h5 elipsis'" :style="{'line-height': '1.5rem', 'color': theme.footerIconColor}"><slot name="main-title"></slot></h2>
                                </v-col>
                                <v-col cols="2" sm="1" align="center" :style="(isXsDevice)?'padding-left: 6%':''"><!--align="end"-->
                                    <v-btn
                                        class=""
                                        elevation="0"
                                        fab
                                        dark
                                        small
                                        @click.stop="setMenuViewActive"
                                        :color="theme.footerIconColor"
                                    >
                                        <v-icon dark opacity="0.5" :color="theme.headerFooterColor">
                                            mdi-close
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 main-card-content" style="overflow-y: auto;height:calc(100% - 160px)" :style="{ 'background-color': theme.backgroundColor}">
                            <HLLoadingMaskOverlay v-show="loadingMain"/>
                            <slot v-show="!loadingMain" name="main"></slot>
                        </v-card-text>
                        <footer :style="{ 'background-color': theme.backgroundColor}">
                            <slot v-show="!loadingMain" name="footer"></slot>
                            <div class="left-card-footer"></div>
                        </footer>
                    </v-card>
                    <!--</transition-group>-->
                </v-flex>
                <!-- </v-fade-transition>-->
            </v-layout>
        </v-container>
    </v-main>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";
import {eventMixin} from "../../utils/event-mixin";
import HLLoadingMaskOverlay from "../ui/HLLoadingMaskOverlay.vue";

export default {
    mixins: [layoutMixin, eventMixin],
    components:{
        HLLoadingMaskOverlay
    },
    props:{
        value:{},
        background:{
            type:String,
            default:null
        },
        backgroundMenu:{
            type:String,
            default:'rgba(255,255,255,0.98)'
        },
        loadingMenu:{
            type:Boolean,
            default:false
        },
        loadingMain:{
            type:Boolean,
            default:false
        },
        insetMenu:{
            type:Boolean,
            default:false
        },
        insetMain:{
            type:Boolean,
            default:false
        },
        singleView:{
            type:Boolean,
            default:false
        },
        hideMenu:{
            type:Boolean,
            default:false
        },
        // the menu card slides in over the background like a drawer; hideMenu then means closed
        // and the menu-handle slot stays visible at its right edge
        drawer:{
            type:Boolean,
            default:false
        },
        autoCheckin:{
            type:Boolean,
            default:false
        },

        transitionKey:{},
        footerBackgroundColor: {},
    },
    watch: {
        'value': {
            handler: function(val) {
                this.activeView=(val)?1:0;
            },
            deep: true,
            immediate: true
        }
    },
    updated() {
        this.assignPseudoElementStyle();
    },
    data(){
        return {
            activeView:0,
            footerBackgroundColorValue: this.footerBackgroundColor
        }
    },
    computed: {
        containerStyle(){

            let style={};

            if(this.isTabletOrPhone && !this.singleView){
                style['height']=`${this.bgHeight}px`;
                style['position']='fixed';
                if(this.isMdDevice){
                    style['padding-top']='75px!important';
                }
            }else{
                style['padding-top']='61px!important';
            }

            return style;
        },
        mainCardStyle(){
            let style={
                'position': 'relative',
                'overflow':'hidden'
            };

            return style;
        },
        cardHeight(){
            // if(this.isSmAndDownDevice && this.menuIsVisible && !this.hideMenu){
            //   return this.bgHeight;
            // }
            if(this.isTabletOrPhone){
                return this.bgHeight-2*56-25;
            }

            return this.bgHeight*0.8
        },
        menuIsVisible(){
            return (this.activeView==0 || this.isMdAndUpDevice) && !this.singleView;
        },
        mainIsVisible(){
            return this.activeView==1 || this.singleView;
        },
        menuTitleStyle(){
            return (this.insetMenu)?{
                'position': 'absolute',
                'z-index': 1,
            }:{};
        },
        mainTitleStyle(){
            return (this.insetMain)?{
                'position': 'absolute',
                'z-index': 1,
                'width': 'calc(100% - 30px)',
                'background-color':this.theme.headerFooterColor,
            }:{
                'background-color':this.theme.headerFooterColor,
            };
        },
        mainCardClass(){
            return (this.insetMain)?"pa-0":"pb-md-4 mobileCard";
        }
    },
    methods: {
        setMenuViewActive(){
            this.activeView=0;
            this.$emit('input',false);
        },
        setMainViewActive(){
            this.activeView=1;
            this.$emit('input',true);
        },
        assignPseudoElementStyle() {
            this.footerBackgroundColorValue = this.theme.headerFooterColor;
            document.documentElement.style.setProperty('--footer-background-color', this.footerBackgroundColorValue);
        }
    }
}
</script>

<style lang="scss">
.menu-toolbar  .v-toolbar__content{
    padding-left:0px!important;
    padding-right:0px!important;
}
</style>
<style scoped>
.mobileCard{
    z-index: 2;
}
/* drawer widths like the native app: 80 % on phones, 50 % from sm; vertically centered like
   the in-flow card (m-auto) */
.menu-drawer{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 80%;
    height: fit-content;
    transition: transform 0.3s ease;
}
.menu-drawer--closed{
    transform: translateX(-100%);
}
@media (min-width: 600px){
    .menu-drawer{
        width: 50%;
    }
}
.menu-drawer__handle{
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
}
.customCard{
    border-top-left-radius:0px!important;
    -moz-border-radius-topleft:0px!important;
    -webkit-border-radius-topleft:0px!important;
    border-bottom-left-radius:0px!important;
    -moz-border-bottom-left-radius:0px!important;
    -webkit-border-bottom-left-radius:0px!important;
}
/* size container: the media row in EspMediaGallery takes its height from this area (cqh units) */
.main-card-content {
    container-type: size;
}

.card-leave-active,
.card-enter-active {
    transition: 1s;
}
.card-enter, .cardleave-to {
    transform: translateX(-100%);
}
.card-enter-to, .card-leave {
    transform: translateX(0);

}
.card-leave-active{

}
.left-card-header {
    height: 64px;
    position: absolute;
    width: 100%;
    background-color: var(--footer-background-color);
    top: 0px;
    z-index: 0;
}
.align-center {
    z-index: 1;
}
.left-card-header-bottom {
    height: 8px;
    position: absolute;
    width: 100%;
    background-color: var(--footer-background-color);
    top: 48px;
}

.v-card > *:last-child:not(.v-btn):not(.v-chip) {
    border-bottom-left-radius: initial;
    border-bottom-right-radius: initial;
}

.v-card{
    div.task-title{
        position:relative;
        &::before{
            content: "";
            position: absolute;
            width: 100%;
            height:64px;
            top: -16px;
            left: 0px;
            z-index: 0;
        }
        h2{
            font-size: 1rem !important;
            line-height: 1rem !important;
        }
        h2.elipsis{
            width:100%;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}

</style>
